import { openaiUsage } from "../openai/usage";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const togetherAi = defineConnector({
  identifier: "togetherAi",
  name: "Together AI",
  tagLine: "Open-model AI inference",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.together\\.(ai|xyz)/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://api.together.ai/settings/projects/~current/api-keys) in your Together AI project settings and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.together.ai/v1/models",
  },
  usage: openaiUsage(),
});
